export default __webpack_public_path__ + "static/media/rapid.2bffc2df.png";